/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.08.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";

import BaseController from "./BaseController";
import Navigation from "../../../Navigation";
import ParamParser from "../../../ParamParser";
import {deepEquals} from "../../../util";

class ListingController extends BaseController {
    static propTypes = {
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired
    };

    static defaultProps = {};


    componentDidMount() {
        // Load data:
        this.actions().clearCollection.defer();
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.resource !== this.props.params.resource) {
            this.actions().clearCollection.defer();
            this.loadData();
        } else {
            if (!deepEquals(prevProps.location.query, this.props.location.query)) this.loadData();
        }
    }

    loadData() {
        // Load in listing:
        this.actions().getCollection.defer({"filter": this.getFilter(), "sort": this.getSort()});
    }

    isStoreChanged(nextProps) {
        if (super.isStoreChanged(nextProps)) return true;
        return nextProps.schema !== this.props.schema;
    }

    getActionData(a) {
        if (this.state.resource)
            return this.state.resource.data;
        return null;
    }

    /**
     *
     * @param {PageAction} action
     * @returns {boolean}
     */
    onAction(action) {
        switch (action.action) {
            case "search":
                Navigation.replaceSearchResource(action.params.resource, action.data);
                return true;
            case "gotoRecord":
                this.actions().gotoRecord.defer(action.data.firstRecord);
                return true;
            case "setPageSize":
                this.actions().setPageSize.defer(action.data.pageSize);
                return true;
            case "setSort":
                this.actions().setSort.defer(action.data.sort);
                return true;
            case "setFilter":
                this.actions().setFilter.defer(action.data.filter);
                return true;
        }
        return super.onAction(action);
    }

    getSort() {
        // let schema = this.getUiSchema();
        let schema = this.getControllerSchema();
        let sort = schema.getSort();
        if (sort) return sort;
        return null;
    }

    getFilter() {
        // let schema = this.getUiSchema();
        let schema = this.getControllerSchema();
        let recSchema = this.getDataSchema();
        let paramParser = new ParamParser(this.props.params, null);
        let filter = _.extend(
            {},
            paramParser.replaceValues(schema.getDefaultFilter()),
            this.props.location.query,
            paramParser.replaceValues(schema.getFilter()));
        return this.makeQueryFilter(recSchema, schema.getSearch(), filter);
    }

    /**
     *
     * @param {Schema} recSchema
     * @param {Object} search
     * @param {Object} query
     */
    makeQueryFilter(recSchema, search, query) {
        if (!search) search = {};
        let filter = {};
        for (let k of _.keys(query)) {
            let op = search[k];
            if (!op &&
                recSchema.field(k).getType() === "string" &&
                !recSchema.field(k).getFormat() &&
                !recSchema.field(k).getEnum()) op = '%';
            if (op) filter[k + op] = query[k];
            else filter[k] = query[k];
        }
        return filter;
    }


}

export default ListingController;
